import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Container } from "reactstrap";

function CareerPageHeader() {
  const pageHeader = useRef(null); // Use 'useRef' instead of 'React.createRef()'
  const [bgImage, setBgImage] = useState("");

  useEffect(() => {
    // Fetch the background image (cover) from the API
    axios
      .get(`${process.env.REACT_APP_API_URL}/Career/readCareer`)
      .then((response) => {
        if (response.data.length > 0) {
          setBgImage(response.data[0].cover); // Assuming 'cover' is the image URL
        }
      })
      .catch((error) => {
        console.error("Error fetching background image:", error);
      });

    // Scroll effect for the page header
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        if (pageHeader.current) {
          let windowScrollTop = window.pageYOffset / 3;
          pageHeader.current.style.transform =
            "translate3d(0," + windowScrollTop + "px,0)";
        }
      };
      window.addEventListener("scroll", updateScroll);

      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  }, []);

  return (
    <>
      <div className="page-header page-header-small">
        <div
          className="page-header-image"
          style={{
            backgroundImage: bgImage ? `url(${bgImage})` : "none",
          }}
          ref={pageHeader} // Assign ref to the element
        ></div>
        <Container>
          <h2 className="title">BERKARIR DI YKBUT</h2>
        </Container>
      </div>
    </>
  );
}

export default CareerPageHeader;
